module.exports = __webpack_public_path__ + "img/October.a18dc8a3.png";